export const getProductionSelectionType = (selection, partnerState, hasInwardBankValue) =>{
    const isOnlyInward = selection === "inward";
    const hasOnlyInwardBank = isOnlyInward && !Boolean(partnerState) && hasInwardBankValue;
    const hasOnlyPayglocal = isOnlyInward && partnerState.every(ele => ele === "payglocal") && !hasInwardBankValue ;
    const hasOnlyXflow =  isOnlyInward && partnerState.every((ele) => ele === "xflow") && !hasInwardBankValue;
    const hasOnlyPartners = hasOnlyPayglocal || hasOnlyXflow;


    return {hasOnlyInwardBank, hasOnlyPayglocal, hasOnlyXflow, hasOnlyPartners, isOnlyInward}
}

export const NEW_REFACTOR =  true;

export const showField = (productList=[], partnerList) => {
    for (const key in partnerList) {
        if (productList.includes(key)) {
            return true;
        }
    }
    return false;
};
